import { ToolbarController } from '../../../layout/toolbar/toolbar.controller';
import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';

/**
 * A Controller that is used for the home page
 */
export class HomePageController {
  private static $inject = [
    '$translate',
    'ACTToolbarService'
  ];
  public currentLocale: string;
  constructor(
    private $translate: ng.translate.ITranslateService,
    private ActToolbarService: ACTToolbarService
  ) {
    this.activate();
  }

  /**
   * Sets the intial state of the home dashboard
   */
  private activate() {
    this.currentLocale = this.$translate.use();
    this.ActToolbarService.getToolbar('primary').then((toolbar: ToolbarController) => {
      toolbar.setDefaults('APP.WELCOME_MESSAGE');
    });
  }
}